











































































































import Vue from 'vue'
export default Vue.extend({
  name: 'LoginContainer',
  props: {
    isPossibleAddPoint: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    gender: {
      type: String,
      required: true
    },
    point: {
      type: String,
      required: true
    },
    addPoint: {
      type: String,
      default: ''
    },
    totalPoint: {
      type: String,
      default: ''
    },
    onCancel: {
      type: Function,
      default: null
    },
    onLogin: {
      type: Function,
      default: null
    },
    onGassan: {
      type: Function,
      default: null
    }
  }
})
